import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { WithholdingTax } from './withholding-tax.interface';

export class WithholdingTaxesService {
   async getWithholdingTaxes() {
      return await http.get<Array<WithholdingTax>>('/withholding-taxes', cacheFirstConfig).then((response) => response.data);
   }
}
